import { Observable, Subscriber } from 'rxjs';
const THREE = (globalThis as any).THREE;

export class Cursor {
    startingSphere: any = null;
    toolName: string = "cursor-tool";
    viewer: any;
    origin: any;
    projectXY: any;
    objects: any;
    offset: { x: number; y: number; z: number } = {
        x: 0,
        y: 0,
        z: 0
    };
    dbIds: any;
    selection: Observable<any[]>;
    // selection: BehaviorSubject<any[]>;
    objSub: Subscriber<any[]> | null = null;
    meshes: THREE.Mesh[] = [];

    constructor(options: any) {
        this.toolName = "Cursor";
        this.objects = options.objects;
        this.viewer = options.viewer;

        this.selection = new Observable(subscriber => {
            this.objSub = subscriber;
        });
        let meshes = this.objects.array ? this.objects.array.map((o:any) => o.mesh) : this.objects.map((o:any) => o.mesh);
        this.meshes = meshes.filter((o:THREE.Mesh) => o);
        // if (!this.dbIds) {
        //     this.dbIds = this.getAllDbIds();
        // }

        // this.meshes = [];

        // if (this.objects && this.objects.length > 0) {

        //     this.objects.forEach((obj: any, index: number) => {
        //         if (obj && obj.mesh) {
        //             this.meshes.push(obj.mesh);
        //         } else {
        //             console.warn(`⚠️ Cursor: Skipping object ${index} - no valid mesh`);
        //         }
        //     });
        // }

        // if (this.meshes.length > 0) {
        //     this.selection = new BehaviorSubject([this.meshes[this.meshes.length - 1]]);
        // } else {
        //     this.selection = new BehaviorSubject<any[]>([]);
        // }
    }

    public activate(): any { }

    public deactivate(): any { }

    getAllDbIds() {
        const { instanceTree } = this.viewer.model.getData()
        const { dbIdToIndex } = instanceTree.nodeAccess

        return Object.keys(dbIdToIndex).map((dbId) => {
            return parseInt(dbId)
        })
    }

    getNames() {
        return [this.toolName];
    };

    getName() {
        return this.toolName;
    };

    pointerToRaycaster(pointer: { clientX: number; clientY: number }): THREE.Raycaster {
        const rect = this.viewer.impl.canvas.getBoundingClientRect();
        const x = ((pointer.clientX - rect.left) / rect.width) * 2 - 1;
        const y = -((pointer.clientY - rect.top) / rect.height) * 2 + 1;

        const raycaster = new THREE.Raycaster();
        const camera = this.viewer.impl.camera;

        if (!camera || !camera.matrixWorld) {
            console.warn("⚠️ Cursor: camera or matrixWorld not ready yet.");
            return raycaster;
        }

        const pointerVector = new THREE.Vector3();
        const pointerDir = new THREE.Vector3();

        if (camera.isPerspective) {
            pointerVector.set(x, y, 0.5);
            pointerVector.unproject(camera);
            raycaster.set(camera.position.clone(), pointerVector.sub(camera.position).normalize());
        } else {
            pointerVector.set(x, y, -1);
            pointerVector.unproject(camera);
            pointerDir.set(0, 0, -1);
            pointerDir.transformDirection(camera.matrixWorld);
            raycaster.set(pointerVector, pointerDir);
        }

        return raycaster;
    }

    handleSingleClick(event: any, button: number): boolean {
        if (button === 0) {
            const pointer = event.pointers ? event.pointers[0] : event;
            const rayCaster = this.pointerToRaycaster(pointer);


            const intersectResults = rayCaster.intersectObjects(this.meshes.filter(m => m.visible), true)
            const hitTest = this.viewer.model.rayIntersect(rayCaster, true, this.dbIds)
            const selections = intersectResults.filter((res) => (!hitTest || (hitTest.distance > res.distance)))
            // const selections = intersectResults;
            if (this.objSub)
                this.objSub.next(selections.map(s => s.object));

            // const visibleMeshes = this.meshes.filter(m => m.visible);
            // const intersectResults = rayCaster.intersectObjects(visibleMeshes, true);

            // // Ici, pas de rayIntersect Forge, uniquement la sélection sur tes meshes custom
            // if (this.selection) {
            //     this.selection.next(intersectResults.map((s: any) => s.object));
            // }
        }
        return false;
    }

    private isValidMeshForCursor(mesh: any): boolean {
        if (!mesh || typeof mesh !== 'object') {
            return false;
        }

        if (!mesh.geometry || !mesh.material) {
            return false;
        }

        if (mesh.geometry.type === "BufferGeometry") {
            const positionAttr = mesh.geometry.attributes?.position;
            return positionAttr && positionAttr.array && positionAttr.array.length > 0;
        }

        return true;
    }
}